import { withAttachments, type ListParams } from '@eo/shared';

import getApiHttpClient from '../../../httpClients/getApiHttpClient';
import type {
  ApproveResponse,
  ApproveTaskBody,
  ClientMembersResponse,
  ClientsResponse,
  ClientTasksResponse,
  HistoryResponse,
  MeetingsResponse,
  QueueResponse,
  TaskTypesResponse,
  RejectResponse,
  RejectTaskBody,
  RevertBody,
  RevertResponse,
} from './types';

export async function fetchQueue(date: string): Promise<QueueResponse> {
  const res = await getApiHttpClient().get<QueueResponse>('/api/v1/cfo/review/queue', {
    params: { date },
  });
  return res.data;
}

export async function fetchHistory(date: string): Promise<HistoryResponse> {
  const res = await getApiHttpClient().get<HistoryResponse>('/api/v1/cfo/review/history', {
    params: { date },
  });
  return res.data;
}

export async function fetchMeetings(date: string): Promise<MeetingsResponse> {
  const res = await getApiHttpClient().get<MeetingsResponse>('/api/v1/cfo/review/meetings', {
    params: { date },
  });
  return res.data;
}

// The routes search, filter and page; the page size is theirs.
export async function searchClients({ search, page }: ListParams): Promise<ClientsResponse> {
  const res = await getApiHttpClient().get<ClientsResponse>('/api/v1/cfo/clients', {
    params: { active: true, ...(search && { search }), page },
  });
  return res.data;
}

export async function searchTaskTypes({ search, page }: ListParams): Promise<TaskTypesResponse> {
  const res = await getApiHttpClient().get<TaskTypesResponse>('/api/v1/cfo/task-types', {
    params: { active: true, ...(search && { search }), page },
  });
  return res.data;
}

export async function approveTask(body: ApproveTaskBody): Promise<ApproveResponse> {
  const res = await getApiHttpClient().post<ApproveResponse>(
    '/api/v1/cfo/review/approve',
    withAttachments(body),
  );
  return res.data;
}

export async function rejectTask(body: RejectTaskBody): Promise<RejectResponse> {
  const res = await getApiHttpClient().post<RejectResponse>('/api/v1/cfo/review/reject', body);
  return res.data;
}

export async function revertDecision(body: RevertBody): Promise<RevertResponse> {
  const res = await getApiHttpClient().post<RevertResponse>('/api/v1/cfo/review/revert', body);
  return res.data;
}

export async function fetchClientMembers(clientId: string): Promise<ClientMembersResponse> {
  const res = await getApiHttpClient().get<ClientMembersResponse>(
    `/api/v1/cfo/clients/${clientId}/members`,
  );
  return res.data;
}

export async function fetchClientTasks(
  clientId: string,
  { search, page }: ListParams,
): Promise<ClientTasksResponse> {
  const res = await getApiHttpClient().get<ClientTasksResponse>(
    `/api/v1/cfo/clients/${clientId}/tasks`,
    { params: { ...(search && { search }), page } },
  );
  return res.data;
}
